import {DefaultPCS, effectiveEPMethod, EPMethod, UVLine} from './render.def';
import s from '../s';
import {isNullOrWhiteSpace, Portal} from '../../util';
import {Font, FONT_FAMILY_MAP} from '../components/engraved-plates/ep-extended/engraved-plate-extended.store';
import {isStaticUVLine, uvLineWeight} from '../components/uv-print/uv-template';

export const prerender_set_pcs = () => {
    if (!s.prod) {
        return;
    }

    // moulding set
    const moulding = s.prod.mouldings.filter(m => m.id === s.ps.moulding_id)[0];
    if (moulding) {
        s.pcs.MouldingID = moulding.id;
        s.pcs.MouldingName = moulding.name;
        s.pcs.MouldingExtWidth = moulding.extWidth;
        s.pcs.rv_moulding = moulding.ResolutionVersion;
    } else {
        // Old/none-style products may not carry a mouldings list (or the selected id
        // isn't in it); the EP/UV old-style overlays still need the moulding ext width
        // to know the physical inches the photo spans (JF_* + ext width).
        s.pcs.MouldingExtWidth = s.ps.moulding_extWidth || 0;
    }

    // todo resolution version (doc 1, doc 2, photo)

    // doc 2 set
    if (s.prod.DocumentID2 > 0) {
        s.pcs.DocumentID2 = s.prod.DocumentID2;
        s.pcs.Base_DocumentName2 = s.prod.DocumentName2;
    }

    // mats set
    if (!s.pcs.IsCAF) {
        const mat = s.prod.mats.filter(m => m.id === s.ps.matcombo_id)[0];
        if (mat) {
            // todo resolution version
            s.pcs.MatCombo_IsWoodFillet = mat.mat2_id === 36 || mat.mat2_id === 38;
            s.pcs.PrimaryMatID = mat.mat1_id;
            s.pcs.PrimaryMatName = mat.pmat_name;
            s.pcs.PrimaryMatColor = mat.pmat_color;
            s.pcs.SecondaryMatID = mat.mat2_id;
            if (s.pcs.SecondaryMatID > 0) {
                s.pcs.SecondaryMatName = mat.smat_name;
                s.pcs.SecondaryMatColor = mat.smat_color;
            }
        }
    } else {
        const mat1 = s.prod.caf_mat1.filter(m => m.id === s.ps.mat1_id)[0];
        const mat2 = s.prod.caf_mat2.filter(m => m.id === s.ps.mat2_id)[0];
        if (mat1) {
            s.pcs.PrimaryMatID = mat1.id;
            s.pcs.PrimaryMatName = mat1.name;
            s.pcs.PrimaryMatColor = mat1.mat_color;
            // todo resolution version
        } else {
            s.pcs.PrimaryMatID = -1;
            s.pcs.PrimaryMatName = '';
            s.pcs.PrimaryMatColor = '';
            s.pcs.rv_mat1 = 1;
        }
        if (mat2) {
            s.pcs.MatCombo_IsWoodFillet = mat2.id === 36 || mat2.id === 38;
            s.pcs.SecondaryMatID = mat2.id;
            s.pcs.SecondaryMatName = mat2.name;
            s.pcs.SecondaryMatColor = mat2.mat_color;
            // todo resolution version
        } else {
            s.pcs.SecondaryMatID = -1;
            s.pcs.SecondaryMatName = '';
            s.pcs.SecondaryMatColor = '';
            s.pcs.rv_mat2 = 1;
        }
    }

    // A product can have EngravedPlateStatusID 0 (legacy "no plate") while still using the newer
    // DB-driven plate templates. In Template mode the plate is always attached (auto-added in s.ts
    // on load), so skip this reset — otherwise ep_id is wiped every render and the plate never
    // shows. Admin mode (ep_type=6) and the old-style overlay (ep_show_oldstyle, toggled by the
    // EPPositionAdmin panel in the admin modes) also auto-add a plate, so they are exempt too.
    // Other modes keep the legacy behavior of removing the plate when status is None.
    if (s.prod.EngravedPlateStatusID === 0 && s.prod.EPMethodID !== EPMethod.Template && s.prod.EPMethodID !== EPMethod.Admin && !s.ps.ep_show_oldstyle) {
        s.pcs.HasEngravedPlate = false;
        s.ps.ep_id = -1;
    }

    s.pcs.DYF_FrameStyleID = s.prod.DYF_FrameStyleID;

    s.pcs.Base_ExtraID = s.prod.ExtraEntityID;
    s.pcs.Base_ExtraEntityName = s.prod.ExtraEntityName;

    s.pcs.state_FlatImageMode = true;
    if (window.innerWidth > 1200) {
        s.pcs.MaxFrameWidthPx = DefaultPCS.DefaultMaxFrameWidth;
    } else if (window.innerWidth > 880) {
        s.pcs.MaxFrameWidthPx = 800;
    } else if (window.innerWidth > 440) {
        s.pcs.MaxFrameWidthPx = window.innerWidth * 0.9;
    } else if (window.innerWidth > 200) {
        s.pcs.MaxFrameWidthPx = window.innerWidth * 0.85;
    } else {
        s.pcs.MaxFrameWidthPx = window.innerWidth * 0.75;
    }
    s.pcs.MaxFrameHeightPx = DefaultPCS.DefaultMaxFrameHeight;

    s.pcs.css.insignia_bot_visible = false;
    s.pcs.Document_Width = s.ps.docWidth;
    s.pcs.Document_Height = s.ps.docHeight;
    s.pcs.Document2_Width = s.ps.docWidth2;
    s.pcs.Document2_Height = s.ps.docHeight2;

    if (s.pcs.DYF_FrameStyleID === 2 && !s.pcs.IsCAF && s.pcs.Document2_Width !== s.pcs.Document_Width && s.pcs.Document2_Width > 0) {
        s.pcs.isHorizontal = s.prod.IsHorizontal;
    } else {
        s.pcs.isHorizontal = s.ps.is_horizontal;
    }

    if (!s.ps.ep_id || s.ps.ep_id <= 0) {
        s.pcs.HasEngravedPlate = false;
    } else {
        s.pcs.HasEngravedPlate = true;
        s.pcs.EngravedPlateID = s.ps.ep_id;
        if (s.ps.ep_id === 37) {
            s.pcs.EngravedPlateName = 'EP_Gold';
        } else if (s.ps.ep_id === 39) {
            s.pcs.EngravedPlateName = 'EP_Silver';
        } else if (s.ps.ep_id === 33146) {
            s.pcs.EngravedPlateName = 'EP_White';
        } else {
            s.pcs.EngravedPlateName = 'EP_Black';
        }
    }

    // insignia width
    const ins = s.prod.insignias.filter(m => m.id === s.ps.insignia_id)[0];
    if (ins && s.ps.insignia_id > 0) {
        s.pcs.Base_InsigniaWidthInches = ins.InsigniaWidthInches > 0 ? ins.InsigniaWidthInches : DefaultPCS.DefaultInsigniaWidthMax;
    }

    // todo resolution version (lino)
    s.pcs.Base_LinoID = s.ps.lino_id;
    s.pcs.Base_LinoName = s.ps.lino_base_name;
    s.pcs.lino_dyf_color = s.ps.lino_dyf_color;

    // todo resolution version(insignia)
    s.pcs.Base_InsigniaID = s.ps.insignia_id;
    s.pcs.Base_InsigniaName = s.ps.insignia_base_name;

    // insignia 2: a fixed Icon Founders Edition (type 92) attribute read straight off the product; never customer selectable
    s.pcs.Base_Insignia2ID = s.prod.ProductTypeID === 92 && s.prod.Insignia2ID > 0 ? s.prod.Insignia2ID : -1;
    s.pcs.Base_Insignia2Name = s.pcs.Base_Insignia2ID > 0 ? s.prod.Insignia2Name : '';
    s.pcs.Base_Insignia2WidthInches = s.pcs.Base_Insignia2ID > 0 ? s.prod.Insignia2WidthInches : 0;

    // mat 3: the fixed third mat of a Dimensions Plus (type 75) product, read straight off the product; never customer selectable
    s.pcs.Mat3ID = s.prod.ProductTypeID === 75 && s.prod.Mat3_ID > 0 ? s.prod.Mat3_ID : -1;
    s.pcs.Mat3Name = s.pcs.Mat3ID > 0 ? s.prod.Mat3Name : '';
    s.pcs.Mat3Color = s.pcs.Mat3ID > 0 ? s.prod.Mat3Color : '';

    // mat overlay: the fixed primary-mat print of a Dimensions Plus (type 75) product, read straight off the product; never customer selectable
    s.pcs.MatOverlayID = s.prod.ProductTypeID === 75 && s.prod.MatOverlayID > 0 ? s.prod.MatOverlayID : -1;

    if (s.pcs.allowUpload1 && s.ui.image_uploaded && s.ps.override_d1_img && s.ps.override_d1_img.length > 5) {
        s.pcs.o3 = s.ps.override_d1_img;
    }

    s.pcs.CustomizationMethodID = s.prod.CustomizationMethod;
    s.pcs.allowUpload1 = s.prod.allowUpload1;
    s.pcs.allowUpload2 = s.prod.allowUpload2;
    s.pcs.ProductID = s.prod.ProductID;
    s.pcs.old_true = s.prod.old_true;
    s.pcs.ADA = GetADA();
    s.pcs.th6Enabled = !s.prod.th6Disabled && !isNullOrWhiteSpace(s.prod.th6);
    s.pcs.IsDefaultConfig = isDefaultConfig();
    s.pcs.ProductName_Original = s.prod.Name;
    s.pcs.PortalID = Portal?.PortalID as number;
    s.pcs.ProductTypeID = s.prod.ProductTypeID;
    s.pcs.VL_BG_Color = s.ps.vlbg_color;
    s.pcs.CDNDomain = Portal?.CDNDomain as string;
    s.pcs.FramePartDomain = `https://${Portal?.CDNDomain}/images/entities/`;
    s.pcs.JF_Width = s.prod.JF_Width;
    s.pcs.JF_Height = s.prod.JF_Height;
    s.pcs.MouldingThickness = s.prod.MouldingThickness;
    s.pcs.lino_is_dyf = s.ps.lino_is_dyf;
    s.pcs.image_uploaded = s.ui.image_uploaded;
    s.pcs.old_style_composite = s.ui.old_style_composite;
    s.pcs.Image_Full = s.prod.Image_Full;

    s.pcs.EP_1 = s.ps.ep1;
    s.pcs.EP_2 = s.ps.ep2;
    s.pcs.EP_3 = s.ps.ep3;
    s.pcs.EP_4 = s.ps.ep4;
    s.pcs.EP_5 = s.ps.ep5;
    s.pcs.EP_6 = s.ps.ep6;
    s.pcs.EP_7 = s.ps.ep7;
    s.pcs.EP_8 = s.ps.ep8;
    s.pcs.EP_9 = s.ps.ep9;
    s.pcs.EP_10 = s.ps.ep10;
    s.pcs.EPBorderType = s.prod.EPBorderType;
    s.pcs.EPContent = s.ps.EPContent;
    s.pcs.EPTemplate = s.ps.EPTemplate;
    s.pcs.EPMethodID = effectiveEPMethod(s.prod.EPMethodID);
    s.pcs.EPSizeType = s.prod.EPSizeType;
    s.pcs.EPWidth = s.prod.EPWidth;
    s.pcs.EPHeight = s.prod.EPHeight;
    if (s.ps.EPWidth > 0) DefaultPCS.DefaultEPWidth = s.ps.EPWidth;
    if (s.ps.EPHeight > 0) DefaultPCS.DefaultEPHeight = s.ps.EPHeight;

    // UV Print
    s.pcs.is_uv_print = s.ps.is_uv_print;
    s.pcs.uv_print_active = s.ps.uv_print_active;
    s.pcs.uv_lines = build_uv_lines();
    // The photo's physical span for the old-style overlay, when the template states it
    // (a product photo that is not a frame, e.g. the INFORMS glass awards).
    s.pcs.uv_photo_w = s.prod.uv_options ? s.prod.uv_options.photo_width : 0;
    s.pcs.uv_photo_h = s.prod.uv_options ? s.prod.uv_options.photo_height : 0;

    // Old-style engraved-plate overlay position + zoom
    s.pcs.ep_xpos = s.ps.ep_xpos || 0;
    s.pcs.ep_ypos = s.ps.ep_ypos || 0;
    s.pcs.ep_zoom = s.ps.ep_zoom > 0 ? s.ps.ep_zoom : 1;
    s.pcs.ep_show_oldstyle = !!s.ps.ep_show_oldstyle;

    // Second engraved plate (template plate2): only "present" while the plate itself is
    // attached and the template resolved a second body with a real size.
    s.pcs.EP2Content = s.ps.EP2Content || '';
    s.pcs.EP2Width = s.ps.EP2Width > 0 ? s.ps.EP2Width : 0;
    s.pcs.EP2Height = s.ps.EP2Height > 0 ? s.ps.EP2Height : 0;
    s.pcs.ep2_xpos = s.ps.ep2_xpos || 0;
    s.pcs.ep2_ypos = s.ps.ep2_ypos || 0;
    s.pcs.ep2_zoom = s.ps.ep2_zoom > 0 ? s.ps.ep2_zoom : 1;
    s.pcs.HasEngravedPlate2 = s.pcs.HasEngravedPlate && s.pcs.EP2Width > 0 && s.pcs.EP2Height > 0 && s.pcs.EP2Content.trim() !== '';
};

const resolveFontFamily = (raw: string): string => {
    if (!raw) return '';
    const asNum = parseInt(raw, 10);

    if (!isNaN(asNum) && FONT_FAMILY_MAP[asNum as Font]) {
        return FONT_FAMILY_MAP[asNum as Font];
    }

    return raw;
};

// Build the resolved render-side UVLine[] from the product's dynamic uv_lines
// template array. Position/size/color are template-fixed; the shopper may edit
// each line's text (value) and font family (font) in place.
const build_uv_lines = (): UVLine[] => {
    const lines: UVLine[] = [];
    const cfg = s.prod.uv_lines || [];
    const required = !!(s.prod.uv_options && s.prod.uv_options.required);

    for (let i = 0; i < cfg.length; i++) {
        const ln = cfg[i];

        if (!ln) {
            continue;
        }

        const x = ln.x;
        const y = ln.y;
        const pt = ln.pt;
        const maxW = ln.max_width;
        const maxH = ln.max_height;

        if (typeof x !== 'number' || typeof y !== 'number' || !pt || !maxW || !maxH) {
            continue;
        }

        const fontFamily = resolveFontFamily(ln.font) || 'Arial, Helvetica, sans-serif';

        lines.push({
            x,
            y,
            fontFamily,
            color: ln.color || '#FFFFFF',
            pt,
            max_width: maxW,
            max_height: maxH,
            text: ln.value || '',
            weight: uvLineWeight(ln),
            // A required template previews its empty editable lines with their placeholder
            // (the proof's "Name" / "Date") - product page only; imagegen never sets it.
            placeholder: required && !isStaticUVLine(ln) && !(ln.value || '').length ? ln.ph || '' : '',
        });
    }

    return lines;
};

// Dimensions Plus (type 75): the fixed third mat, read outside-in after the mat combo the way the cart lists the mats ("Textured Ivory / Gold / Purple")
const mat3Suffix = (): string => (s.prod.ProductTypeID === 75 && s.prod.Mat3_ID > 0 && s.prod.Mat3DisplayName ? ` / ${s.prod.Mat3DisplayName}` : '');

// Dimensions Plus (type 75): the fixed Mat Overlay, named after the matting it is printed on ("... matting printed with the LSU pattern");
// a display name that already ends in "pattern" is used as it is
const matOverlaySuffix = (): string => {
    const name = s.prod.ProductTypeID === 75 && s.prod.MatOverlayID > 0 ? (s.prod.MatOverlayDisplayName || '').trim() : '';
    if (!name) {
        return '';
    }
    return ` printed with the ${/\bpattern$/i.test(name) ? name : `${name} pattern`}`;
};

const GetADA = (): string => {
    if (!s.si && !s.prod) {
        return 'Diploma Frame';
    }

    let ada = `${s.si ? s.si.InstName : ''} ${Portal && Portal?.PortalID < 1 ? `Diploma` : `Document`} Frame`;
    if (s.ps.moulding_id > 0) {
        ada += ` in ${s.ui.title_moulding}`;
    }

    if (!s.prod.IsFrame) {
        ada = s.prod.Name;
    } else if (s.prod.CustomizationMethod < 2) {
        if (s.prod.Mat1_ID > 0) {
            ada += ` with ${s.prod.MatComboName}${mat3Suffix()} matting${matOverlaySuffix()}`;
        }

        if (s.prod.InsigniaID > 0) {
            ada += `, and a ${s.prod.InsigniaDisplayName}`;
        }
        if (s.prod.Insignia2ID > 0 && s.prod.Insignia2DisplayName) {
            ada += `, and a ${s.prod.Insignia2DisplayName}`;
        }
        ada += '.';
    } else {
        if (s.ps.mat1_id > 0 || s.ps.mat2_id > 0) {
            ada += ` with ${s.ui.title_mat_combo}${mat3Suffix()} matting${matOverlaySuffix()}`;
        }

        if (s.ps.insignia_id > 0) {
            ada += `, and a ${s.ui.title_insignia ? s.ui.title_insignia : s.prod.InsigniaDisplayName}`;
        }
        if (s.prod.Insignia2ID > 0 && s.prod.Insignia2DisplayName) {
            ada += `, and a ${s.prod.Insignia2DisplayName}`;
        }
        ada += '.';
    }
    return ada.trim();
};

const isDefaultConfig = (): boolean => {
    return s.prod.MouldingID === s.ps.moulding_id && s.prod.Mat1_ID === s.ps.mat1_id && s.prod.Mat2_ID === s.ps.mat2_id && s.prod.InsigniaID === s.ps.insignia_id && s.prod.EngravedPlateStatusID === s.ps.ep_id && s.prod.LinoID === s.ps.lino_id;
};
